import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";
import { Icon, Card, Elevation } from "@blueprintjs/core";
import ReactGA from "react-ga";

import FullScreenLoader from "../components/FullScreenLoader";

const ThankYouScreen = ({ surveyMethod }) => {
  useEffect(() => {
    ReactGA.event({
      category: "Move Calculator",
      action: "Step",
      label: "Thank You",
    });
  }, []);

  // Calendly survey scheduling disabled at client request.
  // useEffect(() => {
  //   ReactGA.event({
  //     category: "Move Calculator",
  //     action: "Step",
  //     label: "https://calendly.com/nvlsales/30min",
  //   });
  //
  //   if (surveyMethod === "inperson") {
  //     window.top.location.href = "https://calendly.com/nvlsales/30min";
  //   }
  // }, [surveyMethod]);

  return surveyMethod !== "inperson" ? (
    <Container className="thank-you">
      <h3>
        {surveyMethod === "yembo"
          ? "You should received a link to the survey app via SMS shortly."
          : "Your information has been sent to a National Van Lines Move Pro and they should call you in a few minutes."}
      </h3>
      <p>
        If you want to call one of our moving specialists, we&apos;re here to
        help!
      </p>
      <p style={{ margin: "1em 0" }}>
        <span className="quote-summary__contact">
          <a href="tel:855-336-1151" style={{ color: "#ef4044", fontSize: 24 }}>
            <Icon icon="phone" iconSize={24} color="#ef4044" />
            855-336-1151
          </a>
        </span>
      </p>
      <p>
        In the meantime to better prepare for your move, have a look at some of
        our{" "}
        <a href="https://www.nationalvanlines.com/moving-guide/">
          moving resources
        </a>
        .
      </p>
      <h4>Popular posts:</h4>
      <Row className="popular-posts">
        <Col sm={12} md={4}>
          <Card elevation={Elevation.TWO} interactive>
            <a href="https://www.nationalvanlines.com/blog/items-you-should-consider-leaving-behind-when-moving/">
              <img src="assets/images/blog1.jpg" alt="" />
              <h5>Items You Should Consider Leaving Behind When Moving</h5>
            </a>
          </Card>
        </Col>
        <Col sm={12} md={4}>
          <Card elevation={Elevation.TWO} interactive>
            <a href="https://www.nationalvanlines.com/blog/how-much-does-it-cost-to-move/">
              <img src="assets/images/blog2.jpg" alt="" />
              <h5>What&apos;s the Cost of Moving</h5>
            </a>
          </Card>
        </Col>
        <Col sm={12} md={4}>
          <Card elevation={Elevation.TWO} interactive>
            <a href="https://www.nationalvanlines.com/blog/beware-moving-scams/">
              <img src="assets/images/blog3.jpg" alt="" />
              <h5>Beware of Moving Scams</h5>
            </a>
          </Card>
        </Col>
      </Row>
    </Container>
  ) : (
    <FullScreenLoader />
  );
};

ThankYouScreen.propTypes = {
  surveyMethod: PropTypes.oneOf(["yembo", "inperson", "phonecall"]).isRequired,
};

export default ThankYouScreen;
